import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Price from '../Price';
import { PricingLabel, PricingLine } from './styles';


const getSurchargeName = (surcharge) => {
  switch (surcharge.specName) {
    case 'windowRemoval':
      return 'Removal';
    case 'windowHaul':
      return 'Haul Away';
    case 'windowAdjustment':
    case 'windowadjustment':
      return 'Adjustment';
    default:
      return surcharge.displayName;
  }
};

const InstallationPricing = ({
  installationCost,
  measureCredit,
  surcharges,
}) => (
  <Fragment>
    <PricingLine >
      <PricingLabel>Installation</PricingLabel>
      <Price id="installationCost">{installationCost}</Price>
    </PricingLine>

    {surcharges && surcharges.length > 0 && (
        surcharges.map(value => (
          <PricingLine key={value.specName} id={`additionalCost-${value.specName}`}>
            <PricingLabel isSurcharge>{getSurchargeName(value)}</PricingLabel>
            <PricingLabel isSurcharge>{(`$${Math.floor(value.retail / value.value)} x ${value.value}`)}</PricingLabel>
            <Price>{value.retail}</Price>
          </PricingLine>
        ))
    )}
    {measureCredit < 0 && (
      <PricingLine >
        <PricingLabel>Measure Credit</PricingLabel>
        <Price id="measureCredit">{measureCredit}</Price>
      </PricingLine>
    )}
  </Fragment>);
InstallationPricing.propTypes = {
  measureCredit: PropTypes.number.isRequired,
  surcharges: PropTypes.arrayOf(PropTypes.shape({
    cost: PropTypes.number.isRequired,
    retail: PropTypes.number.isRequired,
    specName: PropTypes.string.isRequired,
    specType: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
  })).isRequired,
  installationCost: PropTypes.number.isRequired,
};

export default InstallationPricing;
